import React, { Component } from 'react'
import IPropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'

import { VIRTUAL_LIST_ID } from './constants'

import hocConnect from './hocConnect'
import StackPreloader from '../../../StackPreloader'
import Entity from '../../../../../../../../components/Entity'
import VirtualizedList from '../../../../../../../../components/VirtualizedList'

import './style.scss'

@hocConnect
export default class HistoryContent extends Component {
    static propTypes = {
        forceRender: PropTypes.func.isRequired,
        historyCollection: IPropTypes.list.isRequired,
        loaded: PropTypes.bool.isRequired,
        loadHistory: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
    }

    componentDidMount() {
        const { loading } = this.props

        if (!loading) {
            this.props.loadHistory()
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.historyCollection.size === prevProps.historyCollection.size) {
            // force render is need only when collection has same length, but different content (swapped entities, changed name, etc.)
            if (!this.props.historyCollection.equals(prevProps.historyCollection)) {
                this.props.forceRender(VIRTUAL_LIST_ID)
            }
        }
    }

    renderLoader = () => {
        const { loading, loaded } = this.props

        return loading || !loaded ? <StackPreloader /> : null
    }

    renderItem = (index) => {
        const { historyCollection } = this.props

        return <Entity key={`entity_${index}`} entity={historyCollection.get(index)} />
    }

    render() {
        const { historyCollection } = this.props

        return (
            <div className={'entity-stack-history-content'}>
                {this.renderLoader()}
                <VirtualizedList
                    id={VIRTUAL_LIST_ID}
                    itemsCount={historyCollection.size}
                    itemHeight={61}
                    renderItem={this.renderItem}
                />
            </div>
        )
    }
}
